const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    position: 'relative',
    '& label': {
      marginTop: 0,
      fontSize: '1.0625rem',
      color: theme.palette.text.grey,
    },
  },
  label: {
    '&.shrink': {
      /* Shrink overrides are not straight forward (see https://github.com/mui-org/material-ui/issues/15918) */
      transform: 'translate(14px, -6px) scale(0.8889)',
      backgroundColor: theme.palette.text.white,
      paddingRight: theme.spacing.unit * 0.75,
      fontSize: '1.125rem',
    },
  },
  input: {
    padding: '18.5px 32px 18.5px 14px',
    fontSize: '1.125rem',
    color: theme.palette.text.dark,
    '& textarea': {
      overflow: 'auto',
    },
  },
  clear: {
    position: 'absolute',
    right: theme.spacing.unit / 2,
    top: theme.spacing.unit * 3,
    fontSize: '1.5rem',
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

export default styles;
